import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SplashComponent } from './splash/splash.component';
import { SigninComponent } from './signin/signin.component';
import { SignupComponent } from './signup/signup.component';
import { MainComponent } from './main/main.component';
import { ProfileComponent } from './profile/profile.component';
import { DasboardComponent } from './dasboard/dasboard.component';
import { CreatePolicyComponent } from './create-policy/create-policy.component';
import { PolicyDetailsComponent } from './policy-details/policy-details.component';
import { AllPoliciesComponent } from './all-policies/all-policies.component';
import { IncompleteTransactionsComponent } from './incomplete-transactions/incomplete-transactions.component';
import { ContactComponent } from './contact/contact.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { ForgetPasswordDetailsComponent } from './forget-password-details/forget-password-details.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { VerifyPaymentComponent } from './verify-payment/verify-payment.component';
import { VerifyPaymentWalletComponent } from './verify-payment/verify-payment-wallet.component';
import { authGuard } from './auth.guard';
import { GetQouteComponent } from './get-qoute/get-qoute.component';
import { RequestCertificateEditComponent } from './request-certificate-edit/request-certificate-edit.component';
import { ClaimsComponent } from './claims/claims.component';
import { ClaimDetailComponent } from './claim-detail/claim-detail.component';

const routes: Routes = [
  { path: '', redirectTo: '/splash', pathMatch: 'full' },
  { path: 'splash', component: SplashComponent },
  { path: 'signin', component: SigninComponent },
  { path: 'signup', component: SignupComponent },
  {path: 'forgetPassword', component: ForgetPasswordComponent},
  {path: 'forgetPasswordDetails', component: ForgetPasswordDetailsComponent},
  {path: 'welcome', component: WelcomeComponent},
  {path: 'get-qoute', component: GetQouteComponent},
  {
    path: 'main',
    component: MainComponent,
    canActivate:[authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'create-policy', component: CreatePolicyComponent },
      { path: 'create-policy/:id', component: CreatePolicyComponent },
      { path: 'profile', component: ProfileComponent },
      { path: 'policy-details/:id', component: PolicyDetailsComponent },
      { path: 'policy-details/:id/:chnl', component: PolicyDetailsComponent },
      { path: 'completed-transactions', component: AllPoliciesComponent },
      { path: 'incomplete-transaction', component: IncompleteTransactionsComponent },
      { path: 'dashboard', component: DasboardComponent },
      { path: 'request-edit/:id', component: RequestCertificateEditComponent },
      { path: 'request-edit', component: RequestCertificateEditComponent },
      { path: 'contact', component: ContactComponent },
      { path: 'claims', component: ClaimsComponent },
      { path: 'claimDetails', component: ClaimDetailComponent },
    ]
  },
    { path: 'verify-wallet-payment', component: VerifyPaymentWalletComponent },
    { path: 'verify-payment', component: VerifyPaymentComponent },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
